import { useTranslation } from "react-i18next";

const NotFound: React.FC = () => {
  const { t } = useTranslation();
  return (
    <>
      <h2>{t("ticketNotFound")}</h2>
    </>
  );
};

export default NotFound;
